import { render, staticRenderFns } from "./Preaspirantes.vue?vue&type=template&id=a0a89514&scoped=true"
import script from "./Preaspirantes.vue?vue&type=script&lang=js"
export * from "./Preaspirantes.vue?vue&type=script&lang=js"
import style0 from "./Preaspirantes.vue?vue&type=style&index=0&id=a0a89514&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a89514",
  null
  
)

export default component.exports